import { HOW_IT_WORKS } from '@/lib/content';
import './HowItWorks.css';

export function HowItWorks() {
  return (
    <section className="section" id="how-it-works">
      <div className="container">
        <div className="section__head">
          <span className="overline">How it works</span>
          <h2>Access is released in waves, so we review each request</h2>
          <p className="lead">
            CareBee 1.0 is built — 200+ designed screens, native iOS and Android, and four years of prior
            development including real-world pilots. We are onboarding alongside our first
            discharge-planning partners rather than all at once, which is why this is a request rather
            than an instant signup.
          </p>
        </div>

        <ol className="steps">
          {HOW_IT_WORKS.map((step) => (
            <li className="steps__item" key={step.step}>
              <span className="steps__num" aria-hidden="true">
                {step.step}
              </span>
              <h3 className="steps__title">{step.title}</h3>
              <p className="steps__body">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
